import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { DataTiposGestionesBienesCulturales, ResponseTiposGestionesBienesCulturales } from '../../tabs/documentos-emitidos/models/gestiones-bienes-culturales';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { TipologiasInterface } from 'app/models/tipologias.model';
import { DocumentosEmitidosService } from '../../tabs/documentos-emitidos/documentos-emitidos.service';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FraccionamientoBienCulturalInterface } from '../models/fracciomiento.model';
import { IntegracionesFraccionamientoService } from './integraciones-y-fraccionamiento.service';
import { CONSTANTS } from 'app/core/constants';
import { UtilsService } from 'app/modules/utils-service';
import { Router } from '@angular/router';

@Component({
    selector: 'formulario-integraciones-y-fraccionamiento',
    templateUrl: 'form-integraciones-y-fraccionamiento.component.html',
    imports:[
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatTableModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatIconModule,
    ]
})

export class FormularioIntegracionesFraccionamientoComponent implements OnInit {
    tipoDocumentos:TipologiasInterface[]
    tiposGestionesBienesCulturales: DataTiposGestionesBienesCulturales[] = []
    gestionActual: string = '';
    gestionesSeleccionadas: DataTiposGestionesBienesCulturales[] = [];
    filteredGestiones: DataTiposGestionesBienesCulturales[] = [];
    numeroRegistro: string = '';
    numeroAgregadoRegistro: string = '';
    descripcion:string
    dataForm:FraccionamientoBienCulturalInterface= null
    tituloFormulario: string = '';
    descripsionGestiones: string = '';
    separador:string = ' - ';
    
    constructor(
        public dialogRef: MatDialogRef<FormularioIntegracionesFraccionamientoComponent>,
        private documetosEmitidosService: DocumentosEmitidosService,
        private integracionesFraccionamientoService: IntegracionesFraccionamientoService,
        private utilsService:UtilsService,
        @Inject(MAT_DIALOG_DATA) public data: {
            uu_id:string, 
            noRegistro:string, 
            formFraccionamiento:boolean, 
            descripcion:string, 
            seccionBienesCulturales:number
        },
        private router:Router
    ) { 
        this.getTiposGestionesBines()

        this.separador = this.data.seccionBienesCulturales === CONSTANTS.TIPOLOGIA_ID_SECCION_PREHISPANICA ? '.' : '-'
        this.dataForm= {
            bienCulturalUuid:this.data.uu_id, 
            descripcion:this.data.descripcion, 
            GestionesUuid:[], 
            tipoOperacion: this.data.formFraccionamiento? CONSTANTS.ID_FRACCIONAMIENTO : CONSTANTS.ID_INTEGRACIONES_PLASTICAS, 
            literal:'',
            nombreBienCultural:''
        }
        

        this.numeroRegistro= this.data.noRegistro

        if(this.data.formFraccionamiento){
            this.tituloFormulario = 'Agregar Desmembración o Fraccionamiento de Finca Matriz';
            this.descripsionGestiones = 'Seleccione las gestiones asociadas a la desmembración o fraccionamiento de la finca matriz';
        }else{
            this.tituloFormulario = 'Aplicaciones o Elementos Conformantes a la Finca Matriz';
            this.descripsionGestiones = 'Seleccione las gestiones asociadas a este proceso de aplicacion y elementos conformantes';
        }
    }

    ngOnInit() {}

    selected(event: MatAutocompleteSelectedEvent) {
        const nombreSeleccionado = event.option.value;
        const gestion = this.tiposGestionesBienesCulturales.find(g => g.nombre === nombreSeleccionado);

        if (gestion && !this.gestionesSeleccionadas.some(g => g.gestionUuid === gestion.gestionUuid)) {
            this.gestionesSeleccionadas = [...this.gestionesSeleccionadas, gestion];
        }

    }

    getTiposGestionesBines(){
        this.documetosEmitidosService.getGestionesByBienesCulturales()
            .then((response:ResponseTiposGestionesBienesCulturales)=>{
                this.tiposGestionesBienesCulturales= response.data
            })
    }

    onInputChange() {
        const current = this.gestionActual.toLowerCase();
        if (current) {
        this.filteredGestiones = this.tiposGestionesBienesCulturales.filter(g =>
            g.nombre.toLowerCase().includes(current) &&
            !this.gestionesSeleccionadas.some(sel => sel.gestionUuid === g.gestionUuid)
        );
        } else {
            this.filteredGestiones = this.tiposGestionesBienesCulturales.slice();
        }
    }

    remove(gestion: DataTiposGestionesBienesCulturales): void {
        this.gestionesSeleccionadas = this.gestionesSeleccionadas.filter(g => g.gestionUuid !== gestion.gestionUuid);
        this.onInputChange();
    }

    postfraccionamientoIntegracion() {
        this.dataForm.GestionesUuid = this.gestionesSeleccionadas.map(g => g.gestionUuid);
        this.integracionesFraccionamientoService.postFraccionamientoIntegracion(this.dataForm)
            .then((response:any)=>{
                this.router.navigate(['/bienes-culturales/detalle/', response.data]);
                this.dialogRef.close();
                this.utilsService.openSuccessSnakBar(response.message);  
            })
    }
}